// Angular imports
import { Injectable } from '@angular/core';

// Service imports
import { EnvironmentConfigService } from '../environment-config.service';

// Constant imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';

@Injectable({
  providedIn: 'root'
})
export class PrecisionService {
  constructor(private envConfig: EnvironmentConfigService) {}

  getPrecision(customPrecision?: number): number {
    if (customPrecision !== null && customPrecision !== undefined) {
      return customPrecision;
    } else {
      const precision = localStorage.getItem(
        StorageKeyConstants.userPrecisionKey
      );
      if (!!precision && Number.isInteger(parseInt(precision, 10))) {
        return parseInt(precision, 10);
      }
    }
    return this.envConfig.defaultRounding;
  }

  getCurrencyFormat(): any {
    const customPrecision = this.getPrecision();
    return { type: 'currency', precision: customPrecision };
  }

  getDecimalFormat(): any {
    const customPrecision = this.getPrecision();
    return { type: 'decimal', precision: customPrecision };
  }

  getCountFormat(): any {
    return { type: 'decimal', precision: 0 };
  }

  updatePrecisionPoint(customFormat: string, precision?: number): string {
    const customPrecision = this.getPrecision(precision);
    const precisionFormat = `.${'0'.repeat(customPrecision)}`;
    return customFormat.replace(/.00/gi, precisionFormat);
  }
}
